var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"healthHourse"},[_c('iframe',{attrs:{"src":"https://project.zhuneng.cn/d3m/#/s/a3eba1647f2a4915a9b1ff95328fe904","frameborder":"0"}})])
}]

export { render, staticRenderFns }